import {UI, StyleSheet, styleRule, registerStyle} from "../../../../../../stem-core/src/ui/UI";
import {CoveragePrices} from "./CoveragePrices";
import {CoverageDescription} from "./CoverageDescription";

class CoveragePreviewStyle extends StyleSheet {
    @styleRule
    container = {
        width: "100%",
        backgroundColor: this.themeProps.MERCHANT_CARD_BACKGROUND,
    };

    @styleRule
    title = {
        textAlign: "center",
        textTransform: "uppercase",
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
    };

    @styleRule
    coveragePricesContainer = {
        height: 54,
    };

    @styleRule
    description = {
        padding: "12px 12px 24px",
    }
}

@registerStyle(CoveragePreviewStyle)
export class CoveragePreview extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            coverage: null,
            subscriptionOffers: null,
            displayAfterTaxesPrice: false,
            testId: "coveragePreview"
        }
    }

    render() {
        const {styleSheet} = this;
        const {coverage, subscriptionOffers, displayAfterTaxesPrice} = this.options;

        return [
            <div className={styleSheet.title}>{coverage.getName()}</div>,
            <CoveragePrices className={styleSheet.coveragePricesContainer} offers={subscriptionOffers} displayAfterTaxesPrice={displayAfterTaxesPrice}/>,
            <CoverageDescription className={styleSheet.description} items={coverage.getDescription().items}/>
        ]
    }
}
